import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import Select from "react-select";
import ToggleButton from "react-toggle-button";
import { updateSettings, fetchSettings } from "../../actions/settings";
import { getSubscriptions, createSubscription, updateSubscription, deleteSubscription } from "../../actions/subscription";

import "./Notifications.scss";
import { InputGroup, FormControl } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CreateWebhookForm from "../../components/settings/CreateWebhookForm";
import SubscriptionItem from "../../components/settings/SubscriptionItem";
const WEBHOOKS = {
  ACCOUNT_SETTINGS_KEY: "webhooks",
  NOTIFICATION_RECIPIENT_VIEW: "notificationRecipientView",
};

export const NOTIFICATION_EVENTS = {
  "recipient.item.viewed": "Recipient Item Viewed",
  "system.item.added": "System Item Added",
  "system.item.updated": "System Item Updated",
};
const ReactSwal = withReactContent(Swal);

const selectStyles = (width) => {
  return {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      height: 32,
      width,
      minHeight: 20,
      marginRight: 10,
    }),
  };
};

const headerSamples = [
  {
    title: "Weekly Digests",
    description: "Digest emails go out weekly to you and your team. Modify the distribution list here.",
  },
  {
    title: "System Notifications",
    description: "Connect external systems to Content Camel events. As an example, you can connect Content Camel activity with your CRM.",
  },
  // {
  //   title: 'Slack Integration',
  //   description: 'If your team uses Slack, you can get notifications each time content is added or a wish is made in Content Camel'
  // }
];

const digestOptions = [
  {
    value: "All users",
    label: "All users",
    description: "All users receive the weekly digest",
  },
  {
    value: "Admin only",
    label: "Admin only",
    description: "Only admins receive the weekly digest",
  },
  {
    value: "No one",
    label: "No one",
    description: "Weekly digests are off",
  },
];

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.notificationHookRef = React.createRef();
    this.state = {
      digestUser: props.digestOption ? { value: props.digestOption, label: props.digestOption } : { value: "All users", label: "All users" },
      isWishIncluded: true,
      webhookUrlSharing: props.webhooks && props.webhooks.listValues ? props.webhooks.listValues.notificationRecipientView : "",
      subscriptions: props.subscriptions,
      subscriptionLoading: props.subscriptions.isLoading,
    };
  }

  changeDigestOption = (e) => {
    this.props.updateDigestOption(e.label);
    this.setState({ digestUser: e });
  };
  onCreateSubscription = (data) => {
    this.props.createSubscription(data);
  };

  onEditSubscription = (data) => {
    this.props.updateSubscription(data);
  };
  onClickAddSubscription = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateWebhookForm
          onClose={ReactSwal.clickCancel}
          onSubmit={this.onCreateSubscription}
          userId={this.props.settings.userInfo.userId}
          tenantId={this.props.settings.tenantId}
          subscriptionLoadingState={this.props.subscriptions.isLoading}
        />
      ),
    });
  };

  onClickEditSubscription(subscription) {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateWebhookForm
          onClose={ReactSwal.clickCancel}
          onSubmit={this.onEditSubscription}
          subscription={subscription}
          userId={this.props.settings.userInfo.userId}
          tenantId={this.props.settings.tenantId}
          subscriptionLoadingState={this.props.subscriptions.isLoading}
        />
      ),
    });
  }

  onClickDeleteSubscription(subscription) {
    const subscriptionDataToDelete = {
      disabledEvents: [subscription.eventName],
      deliveryUrl: subscription.deliveryUrl,
      tenantId: this.props.settings.tenantId,
    };
    this.props.deleteSubscription(subscriptionDataToDelete);
  }

  componentDidMount() {
    this.props.getSubscriptions(this.props.settings.tenantId);
  }

  componentDidUpdate(prevProps) {
    // Check if the subscriptions prop has changed
    if (prevProps.subscriptions !== this.props.subscriptions) {
      this.setState({ subscriptions: this.props.subscriptions, subscriptionLoading: this.props.subscriptions.isLoading });
    }
    if (!this.props.subscriptions.isLoading) {
      ReactSwal.clickCancel();
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {
      digestUser: {
        value: props.digestOption,
        label: props.digestOption,
      },
    };
  }

  render() {
    const subscriptionsState = this.state.subscriptions;

    const viewsSubscriptions = subscriptionsState.subscriptions.filter((subscription) => {
      return subscription.eventName == "recipient.item.viewed";
    });

    const contentAddedSubscriptions = subscriptionsState.subscriptions.filter((subscription) => {
      return subscription.eventName == "system.item.added";
    });

    const contentUpdatedSubscriptions = subscriptionsState.subscriptions.filter((subscription) => {
      return subscription.eventName == "system.item.updated";
    });
    return (
      <div className="notifications-container">
        <div className="notification-container">
          <div className="header-wrapper">
            <div className="header-item">
              <h2>{headerSamples[0].title}</h2>
              <p>{headerSamples[0].description}</p>
            </div>
          </div>
          <div className="settings-content-wrapper">
            <div className="digest-container">
              <div className="d-flex align-items-center">
                <Select
                  options={digestOptions}
                  styles={selectStyles(140)}
                  placeholder="Roles"
                  className="selector"
                  value={this.state.digestUser}
                  onChange={this.changeDigestOption}
                />
                <p className="ml-2 mb-0">{_.get(this.state.digestUser, "description", "")}</p>
              </div>
              <div className="d-flex align-items-center mt-2 ml-2">
                <ToggleButton
                  value={this.state.isWishIncluded}
                  thumbStyle={{ borderRadius: 2 }}
                  trackStyle={{ borderRadius: 2 }}
                  colors={{
                    active: {
                      base: "rgb(76,210,126)",
                    },
                  }}
                  onToggle={(value) => {
                    this.setState({
                      isWishIncluded: !value,
                    });
                  }}
                />
                <p className="ml-2 mb-0">
                  {this.state.isWishIncluded
                    ? "New wishes will be included in digest notification"
                    : "New wishes will not be included in digest notification"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="divider" />
        <div className="notification-container">
          <div className="header-wrapper">
            <div className="header-item">
              <h2>{headerSamples[1].title}</h2>
              <p>{headerSamples[1].description}</p>
            </div>
          </div>
          <div className="settings-content-wrapper webhook-wrapper">
            <div className="webhook-details">
              <p>Webhooks</p>
              <InputGroup className="mb-3">
                <Card.Body>
                  <div className="add-subscription-button" onClick={this.onClickAddSubscription}>
                    +
                  </div>
                  <div className="branding-items-list">
                    {viewsSubscriptions.length > 0 && <div className="event-name">{NOTIFICATION_EVENTS["recipient.item.viewed"]}</div>}
                    {viewsSubscriptions &&
                      viewsSubscriptions.map((subscription) => (
                        <div
                          key={subscription.deliveryUrl}
                          style={this.props.subscriptions.isLoading ? { pointerEvents: "none", opacity: 0.5 } : null}
                        >
                          <SubscriptionItem
                            data={subscription}
                            onPreview={() => this.onClickEditSubscription(subscription)}
                            onDelete={() => this.onClickDeleteSubscription(subscription)}
                            onEdit={() => this.onClickEditSubscription(subscription)}
                            loading={this.props.subscriptions.isLoading}
                          />
                        </div>
                      ))}

                    {contentAddedSubscriptions.length > 0 && <div className="event-name">{NOTIFICATION_EVENTS["system.item.added"]}</div>}

                    {contentAddedSubscriptions &&
                      contentAddedSubscriptions.map((subscription) => (
                        <div
                          key={subscription.deliveryUrl}
                          style={this.props.subscriptions.isLoading ? { pointerEvents: "none", opacity: 0.5 } : null}
                        >
                          <SubscriptionItem
                            key={subscription.deliveryUrl}
                            data={subscription}
                            onPreview={() => this.onClickEditSubscription(subscription)}
                            onDelete={() => this.onClickDeleteSubscription(subscription)}
                            onEdit={() => this.onClickEditSubscription(subscription)}
                            loading={this.props.subscriptions.isLoading}
                          />
                        </div>
                      ))}

                    {contentUpdatedSubscriptions.length > 0 && <div className="event-name">{NOTIFICATION_EVENTS["system.item.updated"]}</div>}

                    {contentUpdatedSubscriptions &&
                      contentUpdatedSubscriptions.map((subscription) => (
                        <div
                          key={subscription.deliveryUrl}
                          style={this.props.subscriptions.isLoading ? { pointerEvents: "none", opacity: 0.5 } : null}
                        >
                          <SubscriptionItem
                            key={subscription.deliveryUrl}
                            data={subscription}
                            onPreview={() => this.onClickEditSubscription(subscription)}
                            onDelete={() => this.onClickDeleteSubscription(subscription)}
                            onEdit={() => this.onClickEditSubscription(subscription)}
                            loading={this.props.subscriptions.isLoading}
                          />
                        </div>
                      ))}
                  </div>
                </Card.Body>
              </InputGroup>

            </div>
          </div>
        </div>
        {/* <div className="divider" /> */}
        
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Auth: state.auth.Auth,
  settings: state.settings,
  subscriptions: state.subscriptions,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSettings,
      fetchSettings,
      getSubscriptions,
      createSubscription,
      updateSubscription,
      deleteSubscription,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
